import $ from 'jquery';
import ModalBaseClass from '../../libs/modal/ModalBaseClass';

/**
 * マップモーダル
 */
export default class MapModalClass extends ModalBaseClass {
  constructor() {
    super('#modal_map');
    this.name = 'MapModalClass';

    this.onClickOpenListener = this.onClickOpen.bind(this);
  }

  onCreate() {
    super.onCreate();
    $('.js-modal_map').on('click', this.onClickOpenListener);
  }

  onClickOpen(e) {
    e.preventDefault();
    const _this = $(e.currentTarget);
    $('.wrap_map_embed', this.modal).attr({ 'data-lat': _this.attr('data-lat'), 'data-lng': _this.attr('data-lng') });
    this.onOpen();
  }
}
